import React from "react";
import LoggedOutFrame from "../components/LoggedOutFrame";

interface props {
  bg: string;
}

const LoggedOut: React.FC<props> = ({ bg }) => {
  return (
    <div className="w-full h-full bg-black">
      <div className="opacity-70 blur-sm absolute top-0 left-0 bg-[url(./assets/bg.png)] w-full h-full bg-center"></div>
      <LoggedOutFrame></LoggedOutFrame>
    </div>
  );
};

export default LoggedOut;
